const blogPosts = [
  {
    id: 1,
    title:
      "Tranquility Distributors Partners with Local Markets for Clean Cooking",
    date: "2026-04-10",
    time: "10:00 hrs",
    author: "Marketing Team",
    category: "Partnerships",
    images: [
      "/images/blog/clean-cooking-1.jpg",
      "/images/blog/clean-cooking-2.jpg",
    ],
    content: `
      <p>Tranquility Distributors has launched a new initiative to bring clean LPG cooking solutions to open markets across Lusaka. The program offers discounted starter kits and free safety demonstrations.</p>
      <p>“We believe that every household deserves safe, affordable energy,” said CEO Mr. Daniel Lyatumba. The first event took place at Tuesday Market, with over 200 families registered.</p>
      <p>Look out for our upcoming events at Soweto and Kamwala markets.</p>
    `,
  },
  {
    id: 2,
    title: "USAID Grant to Boost Rural LPG Access",
    date: "2026-03-22",
    time: "14:30 hrs",
    author: "Admin",
    category: "Funding",
    images: ["/images/blog/usaid-grant.jpg"],
    content: `
      <p>Tranquility Distributors has been awarded a USAID grant to expand LPG distribution in rural areas surrounding Lusaka. The project will establish three new mini‑depots in Chongwe, Kafue and Makeni.</p>
      <p>This funding will also support community education on the benefits of switching from charcoal to LPG.</p>
    `,
  },
  {
    id: 3,
    title: "AFROX Handigas Renews Exclusive Partnership",
    date: "2026-02-15",
    time: "09:00 hrs",
    author: "Management",
    category: "Partnerships",
    images: ["/images/blog/afrox-renewal.jpg"],
    content: `
      <p>Tranquility Distributors and AFROX Zambia have renewed their exclusive distribution agreement for another five years. The partnership ensures a steady supply of high‑quality Handigas LPG across all outlets.</p>
      <p>The agreement also includes joint safety training and customer awareness campaigns.</p>
    `,
  },
  {
    id: 4,
    title:
      "Forward 7 LPG Donation Initiative – Empowering Clean Cooking in Kanyama",
    date: "2026-05-06",
    time: "11:00 hrs",
    author: "Management",
    category: "Community Impact",
    images: ["/images/blog/clean-cooking-2.jpg"],
    content: `
    <p><strong>Forward 7</strong>, a Saudi‑based organisation, has donated <strong>200 units of 6kg LPG cylinders</strong> to Zambia through <strong>AFROX Zambia</strong>, a member of the Linde Group. Tranquility Distributors is honoured to serve as the implementing partner for this important clean‑energy initiative.</p>
    
    <p>The project targets low‑income households in <strong>Kanyama Constituency</strong>, with the aim of accelerating the transition from charcoal to cleaner, safer, and more efficient cooking solutions. Each beneficiary receives a 6kg LPG cylinder filled with gas, along with a brief orientation at our facility on safe handling and effective use of LPG.</p>
    
    <p>Recipients are expected to become community advocates and champions of clean cooking, helping to spread awareness of the economic and health benefits of LPG. To support sustained adoption, beneficiaries can refill their cylinders from as little as <strong>½ kg (K25)</strong>, enabling them to directly compare the cost and efficiency of LPG against charcoal.</p>
    
    <p>Over time, this initiative is expected to inspire broader community transformation, with more households embracing LPG as a modern, affordable, and environmentally friendly cooking solution.</p>
    
    <p>The <strong>first batch of recipients</strong> received their packs last week on <strong>Thursday, 30th April, 2026</strong>. The next batch of recipients will receive their packs starting tomorrow <strong>6th May, 2026 </strong> until <strong>Friday 8th May, 2026</strong>.</p>
    
    <p>Tranquility Distributors extends its gratitude to Forward 7 and AFROX Zambia for making this vision a reality. We look forward to a cleaner, healthier Kanyama.</p>
  `,
  },
  {
    id: 5,
    title: "BETUZ & Tranquility Distributors Sign MoU for Clean Cooking",
    date: "2026-05-20",
    time: "09:30 hrs",
    author: "Management",
    category: "Partnership",
    images: ["/images/blog/betuz.png"],
    content: `
    <p>The <strong>Basic Teachers Union of Zambia (BETUZ)</strong> and <strong>Tranquility Distributors Ltd</strong> have formalised a strategic partnership through a Memorandum of Understanding (MoU) aimed at expanding access to clean cooking solutions for teachers across the country.</p>

    <p>BETUZ is a nationally recognised teachers’ union representing educators primarily within the basic education subsector. It operates across all provinces of Zambia with an extensive grassroots presence in schools. The union’s core mandate includes:</p>

    <ul>
      <li>Advocating for improved working conditions, remuneration, and professional development for teachers.</li>
      <li>Promoting quality education standards and supporting government and sector reforms.</li>
      <li>Providing member services including welfare support, training, and administrative facilitation.</li>
    </ul>

    <p>The MoU leverages BETUZ’s broad membership network and Tranquility Distributors’ established LPG distribution capacity to deliver an <strong>affordable, safe, and scalable LPG adoption programme</strong>. Under this partnership, teachers nationwide will gain access to discounted LPG starter kits, flexible payment plans, and continuous safety education.</p>

    <p>The initiative aligns with the Zambian government’s goal of promoting clean cooking and reducing deforestation. By targeting educators – key influencers in their communities – the programme is expected to create a ripple effect, encouraging wider adoption of LPG among households.</p>`,
  },
  {
    id: 6,
    title: "AFROX Management Pays Courtesy Visit to Tranquility Distributors",
    date: "2026-05-27",
    time: "10:00 hrs",
    author: "Management",
    category: "Partnership",
    images: ["/images/blog/afrox-meeting.jpg"],
    content: `
    <p>We were honoured to receive <strong>AFROX Managing Director, Mr. Hendrix Munyinda</strong> (standing left), and <strong>Regional Manager – Northern Region, Mr. Victor Kapanda</strong> (standing centre), during their courtesy visit to our offices today. Their engagement reaffirmed our mutual commitment to deepening strategic partnerships, upholding the highest safety standards, and advancing the expansion of clean energy access across Zambia.</p>

    <p>AFROX is a leading supplier of industrial and medical gases, including liquefied petroleum gas (LPG), with a strong footprint across Zambia. The company is renowned for its rigorous safety protocols, reliable supply chains, and commitment to promoting clean energy alternatives. This visit builds on a long-standing relationship between AFROX and Tranquility Distributors Ltd, focused on driving LPG adoption in residential and commercial markets.</p>

    <p>Discussions during the visit centred on collaborative initiatives to enhance LPG accessibility, improve safety training for distributors and end-users, and explore new models for reaching underserved communities. Both teams agreed to intensify joint efforts in supporting Zambia’s transition away from traditional biomass fuels, aligning with national environmental and health goals.</p>

    <p>The presence of senior AFROX leadership underscores the strategic importance of our partnership. We look forward to rolling out expanded clean cooking programmes and innovative distribution solutions in the coming months, with safety and customer empowerment at the core of every step.</p>`,
  },
];

export default blogPosts;
